// Mirrors backend apps/user_profile/constants.py — NotificationEventType

// Document Generation Jobs (external ingestion service)
export const GENERATION_JOB_STARTED = 'generation_job.started';
export const GENERATION_JOB_PROCESSING = 'generation_job.processing';
export const GENERATION_JOB_COMPLETED = 'generation_job.completed';
export const GENERATION_JOB_FAILED = 'generation_job.failed';

// Cap Table Spreadsheet Mapping jobs
export const CAP_TABLE_MAPPING_STARTED = 'cap_table_mapping.started';
export const CAP_TABLE_MAPPING_PROCESSING = 'cap_table_mapping.processing';
export const CAP_TABLE_MAPPING_COMPLETED = 'cap_table_mapping.completed';
export const CAP_TABLE_MAPPING_FAILED = 'cap_table_mapping.failed';

// Financial Mapping jobs (XLSX attribute mapping)
export const FINANCIAL_MAPPING_STARTED = 'financial_mapping.started';
export const FINANCIAL_MAPPING_PROCESSING = 'financial_mapping.processing';
export const FINANCIAL_MAPPING_COMPLETED = 'financial_mapping.completed';
export const FINANCIAL_MAPPING_FAILED = 'financial_mapping.failed';

// PDF Processing jobs (table extraction)
export const PDF_PROCESSING_STARTED = 'pdf_processing.started';
export const PDF_PROCESSING_PROCESSING = 'pdf_processing.processing';
export const PDF_PROCESSING_COMPLETED = 'pdf_processing.completed';
export const PDF_PROCESSING_FAILED = 'pdf_processing.failed';

// Parsing jobs
export const PARSING_STARTED = 'parsing.started';
export const PARSING_PROCESSING = 'parsing.processing';
export const PARSING_COMPLETED = 'parsing.completed';
export const PARSING_FAILED = 'parsing.failed';

// Document events (non-job)
export const DOCUMENT_UPLOADED = 'document_uploaded';

// Workboard events
export const FULFILLMENT_ASSIGNED_AS_PREPARER = 'fulfillment.assigned_as_preparer';
export const FULFILLMENT_ASSIGNED_AS_REVIEWER = 'fulfillment.assigned_as_reviewer';
export const FULFILLMENT_UNASSIGNED_AS_PREPARER = 'fulfillment.unassigned_as_preparer';
export const FULFILLMENT_UNASSIGNED_AS_REVIEWER = 'fulfillment.unassigned_as_reviewer';
export const FULFILLMENT_STATUS_CHANGED = 'fulfillment.status_changed';

// Fulfillment roles
export const FULFILLMENT_ROLE_PREPARER = 'preparer' as const;
export const FULFILLMENT_ROLE_REVIEWER = 'reviewer' as const;
export type FulfillmentRole = typeof FULFILLMENT_ROLE_PREPARER | typeof FULFILLMENT_ROLE_REVIEWER;
